import { fintracService } from "@services/apis/Fintrac";
import { FintracJobRun } from "@services/models/Fintrac/FintracModel";
import { ColDef, RowClickedEvent } from "ag-grid-community";
import { useCallback, useMemo } from "react";
import {
  FintracHeader,
  fintracCountColumn,
  fintracNumberColumn,
  FintracStatusPill,
  FintracTable,
  fintracTextColumn,
} from "./fintracChrome";
import { useFintracList } from "./useFintracList";

const JobRunsScreen = ({
  onOpen,
}: {
  onOpen: (job: FintracJobRun) => void;
}) => {
  const load = useCallback(async (page: number, limit: number) => {
    const response = await fintracService.listJobRuns({ page, limit });
    return {
      rows: response.data.jobRuns ?? [],
      pagination: response.data.pagination,
    };
  }, []);

  const list = useFintracList("job-runs", load);

  const columnDefs = useMemo<ColDef[]>(
    () => [
      fintracNumberColumn("id", "Job Id", 96, "Job ID copied!"),
      fintracTextColumn("reportDate", "Report date", 122),
      fintracTextColumn("windowStart", "Window start", 162),
      fintracTextColumn("windowEnd", "Window end", 162),
      fintracCountColumn("qualifyingUserCount", "# Users", 88, "users"),
      fintracCountColumn(
        "qualifyingTransactionCount",
        "# Transactions",
        120,
        "transactions",
      ),
      {
        field: "status",
        headerName: "Status",
        width: 128,
        minWidth: 178,
        cellRenderer: (params) => (
          <div className="flex h-full items-center">
            <FintracStatusPill
              status={params.value === "COMPLETED" ? "GENERATED" : params.value}
            />
          </div>
        ),
      },
      fintracTextColumn("errorMessage", "Error", 210),
      fintracTextColumn("createdAt", "Created", 162),
    ],
    [],
  );

  const onRowClicked = (event: RowClickedEvent<FintracJobRun>) => {
    if (event.data) onOpen(event.data);
  };

  return (
    <div className="flex h-full flex-col overflow-hidden bg-bg-page-body">
      <FintracHeader crumbs={[{ label: "FINTRAC" }]} />
      <div className="flex min-h-0 flex-1 flex-col px-[16px] pb-[16px] pt-[12px]">
        <div className="min-h-0 flex-1">
          <FintracTable
            columnDefs={columnDefs}
            rows={list.rows}
            loading={list.loading}
            loadingMore={list.loadingMore}
            error={list.error}
            totalRecords={list.pagination.totalRecords}
            hasMore={list.hasMore}
            onLoadMore={list.loadMore}
            onRowClicked={onRowClicked}
          />
        </div>
      </div>
    </div>
  );
};

export default JobRunsScreen;
